<template>
  <div>
    <q-form
      :ref="formStructure.key"
      class="waybill-form"
      :model="model"
      :rules="modelRules"
      label-width="120px"
    >
      <q-form-item
        label="تاریخ شروع"
        prop="startDate"
      >
        <persian-date-picker
          v-model="model.startDate"
          :editable="true"
        />
      </q-form-item>

      <q-form-item
        label="تاریخ پایان"
        prop="endDate"
      >
        <persian-date-picker
          v-model="moedl.endDate"
          :editable="true"
        />
      </q-form-item>

      <q-form-item
        label="تاریخ تحویل"
        prop="deliveryDate"
      >
        <persian-date-picker
          v-model="model.deliveryDate"
          :editable="true"
        />
      </q-form-item>
      <q-form-item
        label="وضعیت"
        prop="status"
      >
        <q-radio
          v-model="model.status"
          label="delivered"
        >
          تحویل شده
        </q-radio>
        <q-radio
          v-model="model.status"
          label="notDelivered"
        >
          تحویل نشده
        </q-radio>
        <q-radio
          v-model="model.status"
          label="all"
        >
          همه بارنامه ها
        </q-radio>
      </q-form-item>

      <q-form-item
        label="نفتکش"
        prop="truck"
      >
        <q-model-selector
          v-model="model.truck"
          plugin="gama"
          delegate="getTrucks"
          display-field="title"
          value-field="id"
          placeholder="..."
          style="width: 100%"
        />
      </q-form-item>
      
      <q-form-item
        label="مسیر"
        prop="route"
      >
        <q-model-selector
          v-model="model.route"
          plugin="gama"
          delegate="getRoutes"
          display-field="title"
          value-field="id"
          placeholder="..."
          style="width: 100%"
        />
      </q-form-item>

      <q-form-item>
        <q-button
          type="primary"
          @click="print()"
        >
          <span>Print</span>
        </q-button>
      </q-form-item>
    </q-form>
  </div>
</template>

<script>
import reportMixin from "../../../models/reportMixin";

export default {
  name: "QGamaWaybillReport",

  mixins: [reportMixin],
  props: {
    formStructure: {required: true, type: Object}
  },
  data() {
    return {
      model: {
        startDate: undefined,
        endDate: undefined,
        deliveryDate: undefined,
        status: 'delivered',
        truck: undefined,
        route: undefined,
      },
      modelRules: {}
    };
  },
  methods: {
    print() {
      this.$refs[this.formStructure.key].validate((valid) => {
        if (valid) {
          this.createReport({
            reportKey: 'waybillReport',
            delegateData: this.model
          });
          this.readonly = true;
        } else {
          this.$notify({
            title: this.$qt('notify.exceptionTitle'),
            message: this.$qt('validation.completeFormMessage'),
            type: 'error'
          });
          return false;
        }
      });
    }
  },
};

</script>

<style scoped>

</style>
